// LP_banner_slider js
var LP_banner_swiper = new Swiper(".LP_banner_slider", {
  effect: 'fade',
  autoplay: {
    speed: 3000,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },
});

// FAQ js
$(".LP_image_faq_container_single_faq_question_container").on("click", function(){
  $(this).closest(".LP_image_faq_container_single_faq").siblings().removeClass("active");
  $(this).closest(".LP_image_faq_container_single_faq").siblings().find(".LP_image_faq_container_single_faq_answer").slideUp();
  $(this).closest(".LP_image_faq_container_single_faq").toggleClass("active");
  $(this).siblings(".LP_image_faq_container_single_faq_answer").slideToggle();
})

$(".LP_image_faq_container_single_faq:first-child .LP_image_faq_container_single_faq_question_container").click();


$(document).ready(function () {
  const simplebarEl = $('.simplebar')[0];

  if (simplebarEl) {
    new SimpleBar(simplebarEl);
  }
});

$(".LP_Affiliate_category_innersides_innerright_innerboths_title_new").click(function () {
  $(this).parents(".LP_Affiliate_category_innersides_innerright_innerboths_new").toggleClass("open");
})

$(document).mouseup(function(e) 
{
    var container = $(".LP_Affiliate_category_innersides_innerright_innerboths_new");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
        $(".LP_Affiliate_category_innersides_innerright_innerboths_new").removeClass("open");
    }
});

/* LP_Affiliate_product_list_slider */
new Swiper('.LP_Affiliate_product_list_slider', {
  loop: true,
  grabCursor: true,
  spaceBetween: 0,
  slidesPerGroup: 1,
  slidesPerView: 1,
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  }
})


document.addEventListener("DOMContentLoaded", function() {
  function removeDisabledSlides() {
    const isMobile = window.matchMedia("(max-width: 989px)").matches;

    // Target all Swiper / slider lists
    const sliders = document.querySelectorAll(".swiper, .slider");

    sliders.forEach(slider => {
      const disabledSlides = slider.querySelectorAll(".disable-mob");

      disabledSlides.forEach(slide => {
        if (isMobile) {
          slide.remove();
        }
      });
    });
  }

  removeDisabledSlides();

  // Optional: re-check on resize
  window.addEventListener("resize", removeDisabledSlides);
});


document.addEventListener("DOMContentLoaded", () => {
  const sliderSections = document.querySelectorAll(".custom-testimonial-sec");

  sliderSections.forEach((section) => {
    const slider = section.querySelector(".slider--desktop");
    if (!slider) return;

    // slide elements — if Swiper, slides are li.swiper-slide; else regular li
    const slides = slider.querySelectorAll("li");
    if (slides.length === 0) return;

    const currentCounter = section.querySelector(".slider-counter--current");
    const totalCounter = section.querySelector(".slider-counter--total");
    totalCounter.textContent = slides.length;
    currentCounter.textContent = 1;

    // Create dots wrapper
    const dotsWrapper = document.createElement("div");
    dotsWrapper.classList.add("slider-dots");
    slides.forEach((_, index) => {
      const dot = document.createElement("button");
      dot.classList.add("slider-dot");
      if (index === 0) dot.classList.add("active");
      dot.dataset.index = index;
      dotsWrapper.appendChild(dot);
    });
    // Insert after counter
    const counterEl = section.querySelector(".slider-counter");
    if (counterEl) counterEl.after(dotsWrapper);
    else section.appendChild(dotsWrapper);

    // Try to find a Swiper instance associated with this slider
    // Common places: the .swiper element, the slider itself, or its closest parent
    const swiperEl =
      section.querySelector(".swiper") ||
      slider.closest(".swiper") ||
      slider; // fallback

    // Some themes attach Swiper instance to the DOM element as `.swiper`
    const swiperInstance = swiperEl && swiperEl.swiper ? swiperEl.swiper : null;

    // Helper to update dots/counter UI
    function updateUIByIndex(index) {
      // clamp index
      const i = Math.max(0, Math.min(slides.length - 1, index));
      // update counter
      if (currentCounter) currentCounter.textContent = i + 1;
      // update dots
      dotsWrapper.querySelectorAll(".slider-dot").forEach((d) => d.classList.remove("active"));
      if (dotsWrapper.children[i]) dotsWrapper.children[i].classList.add("active");
    }

    // ----------------- Case A: If Swiper instance exists -----------------
    if (swiperInstance) {
      // When Swiper changes slide, update dots & counter
      // Use realIndex to avoid loop clones
      swiperInstance.on("slideChange", () => {
        const real = typeof swiperInstance.realIndex !== "undefined" ? swiperInstance.realIndex : swiperInstance.activeIndex;
        updateUIByIndex(real);
      });

      // Dot clicks -> call swiper.slideTo
      dotsWrapper.addEventListener("click", (e) => {
        const dot = e.target.closest(".slider-dot");
        if (!dot) return;
        const index = parseInt(dot.dataset.index, 10);

        // If swiper is looped, slideTo needs (index + loopedSlides) or use slideToLoop
        if (typeof swiperInstance.slideToLoop === "function") {
          swiperInstance.slideToLoop(index); // handles looped slides
        } else {
          swiperInstance.slideTo(index);
        }
      });

      // Initial sync (in case Swiper started on a non-zero slide)
      const initIndex = typeof swiperInstance.realIndex !== "undefined" ? swiperInstance.realIndex : swiperInstance.activeIndex || 0;
      updateUIByIndex(initIndex);

      return; // done for Swiper case
    }

    // ----------------- Case B: No Swiper -> fallback to native scroll -----------------
    // compute slide width on demand
    const getSlideWidth = () => {
      return slides[0].offsetWidth || slides[0].getBoundingClientRect().width;
    };

    // goToSlide for native scroll
    function goToSlide(index) {
      const slideWidth = getSlideWidth();
      slider.scrollTo({
        left: slideWidth * index,
        behavior: "smooth",
      });
      updateUIByIndex(index);
    }

    // dot click handler (native)
    dotsWrapper.addEventListener("click", (e) => {
      const dot = e.target.closest(".slider-dot");
      if (!dot) return;
      const index = parseInt(dot.dataset.index, 10);
      goToSlide(index);
    });

    // update UI while scrolling
    slider.addEventListener("scroll", () => {
      // round to nearest slide
      const width = getSlideWidth();
      if (width === 0) return;
      const index = Math.round(slider.scrollLeft / width);
      updateUIByIndex(index);
    });

    // on resize keep same slide visible
    window.addEventListener("resize", () => {
      const activeIndex = Math.round(slider.scrollLeft / getSlideWidth());
      goToSlide(activeIndex);
    });

    // initial UI set
    updateUIByIndex(0);
  });
});



// document.addEventListener("DOMContentLoaded", function () {
//   function initCustomAuthorSlider() {
//     const sliderEl = document.querySelector(".custom-author-sec .slider-mobile-gutter.swiper");

//     if (!sliderEl) return;

//     // Destroy old instance if already initialized
//     if (sliderEl.swiper) {
//       sliderEl.swiper.destroy(true, true);
//     }

//     // Initialize Swiper
//     const newSwiper = new Swiper(sliderEl, {
//       slidesPerView: "auto",
//       spaceBetween: 26,
//       loop: false,
//       speed: 600,
//       grabCursor: true,
//       watchSlidesProgress: true,
//       freeMode: true,
//     });
//     console.log("Custom Author Swiper initialized:", newSwiper);
//   }

//   function removeDisabledSlidesAndReinit() {
//     const isMobile = window.matchMedia("(max-width: 750px)").matches;
//     const slider = document.querySelector(".custom-author-sec .slider-mobile-gutter .swiper");

//     if (!slider) return;

//     const disabledSlides = slider.querySelectorAll(".disable-mob");
//     disabledSlides.forEach(slide => {
//       if (isMobile) slide.remove();
//     });

//     initCustomAuthorSlider();
//   }

//   removeDisabledSlidesAndReinit();

//   // Re-check and reinit on resize
//   window.addEventListener("resize", removeDisabledSlidesAndReinit);
// });

(async () => {
  const sectionEl = document.querySelector(`[data-ele="multicolumn-section"]`);
  if (!sectionEl) return;

  const allBlocks = sectionEl.querySelectorAll('.multicolumn-list__item');
  if (!allBlocks.length) return;

  // Helper functions
  const textOf = (el) => (el ? (el.textContent || '').trim() : '');
  const attrOf = (el, name) => (el ? el.getAttribute(name) || '' : '');
  const slugify = (text) =>
    text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/['’]/g, '-')
      .replace(/\s+/g, '-')
      .replace(/[^\w\-]+/g, '')
      .replace(/\-\-+/g, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '');

  // ------------------------
  // 🔹 Unified Shopify Fetcher
  // ------------------------
  async function fetchArticleDetailsFromShopify({ title = '', blogHandle = '', excludeTags = [], includeTags = '', blogId='' } = {}) {
    const apiEndPoint = 'https://info.thepauselife.com/shopify-blogs-api/';
    //const apiEndPoint = 'https://demo.creativeisk.com/thepauselife/shopify-blogs-api/';
    
    const SHOP = Shopify.shop;
    const params = new URLSearchParams({
      SHOP,
      PER_PAGE: 1,
    });

    if (title) params.append('SEARCH', title.trim());
    if (blogHandle) params.append('BLOG_HANDLE', blogHandle);
    if (blogId) params.append('BLOG_ID', blogId);
    if (excludeTags.length) params.append('EXCLUDE_TAGS', JSON.stringify(excludeTags));
    if (includeTags.length) params.append('INCLUDE_TAGS', JSON.stringify(includeTags));

    const url = `${apiEndPoint}?${params.toString()}`;
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();

      const node = data?.data?.articles?.edges?.[0]?.node;
      if (!node) return null;

      const article = {
        id: node.id,
        title: node.title,
        handle: node.handle,
        description: node.description || '',
        image: node.image?.url || '',
        link: `/blogs/${node.blog?.handle || blogHandle}/${node.handle}`,
        metafields: {},
      };

      if (node.metafields?.edges?.length) {
        node.metafields.edges.forEach((mf) => {
          article.metafields[mf.node.key] = mf.node.value;
        });
      }

      return article;
    } catch (err) {
      console.error('[Shopify Fetch Error]', err);
      return null;
    }
  }

  // ------------------------
  // 🔹 RSS Parser (kept intact)
  // ------------------------
  const parseRSS = (xmlText, feedIndex = 0, blogHandle = '') => {
    const doc = new DOMParser().parseFromString(xmlText, 'text/xml');
    let items = [...doc.querySelectorAll('channel > item')];
    if (!items.length) items = [...doc.querySelectorAll('feed > entry')];
    if (!items.length) return null;

    const it = items[feedIndex] || items[0];
    const title = textOf(it.querySelector('title')) || 'Untitled';
    let description =
      textOf(it.querySelector('description')) ||
      textOf(it.querySelector('content\\:encoded')) ||
      textOf(it.querySelector('summary')) ||
      '';

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = description;
    description = (tempDiv.textContent || tempDiv.innerText || '').trim();

    // --- Image extraction (untouched) ---
    let image = '';
    const itunesImg =
      it.querySelector('itunes\\:image') ||
      Array.from(it.getElementsByTagName('*')).find(
        (el) => el.localName === 'image' && el.namespaceURI && el.namespaceURI.includes('itunes')
      );
    if (itunesImg) image = attrOf(itunesImg, 'href') || attrOf(itunesImg, 'url');

    if (!image) {
      const mediaThumbnail =
        it.querySelector('media\\:thumbnail') ||
        Array.from(it.getElementsByTagName('*')).find(
          (el) => el.localName === 'thumbnail' && el.namespaceURI && el.namespaceURI.includes('media')
        );
      if (mediaThumbnail) image = attrOf(mediaThumbnail, 'url') || attrOf(mediaThumbnail, 'href');
    }

    if (!image) {
      const mediaContent =
        it.querySelector('media\\:content[type^="image"]') ||
        Array.from(it.querySelectorAll('media\\:content')).find((el) => {
          const type = attrOf(el, 'type');
          return type && type.startsWith('image');
        });
      if (mediaContent) image = attrOf(mediaContent, 'url') || attrOf(mediaContent, 'href');
    }

    if (!image) {
      const imageEnclosure = Array.from(it.querySelectorAll('enclosure')).find((el) => {
        const type = attrOf(el, 'type');
        return type && type.startsWith('image');
      });
      if (imageEnclosure) image = attrOf(imageEnclosure, 'url') || attrOf(imageEnclosure, 'href');
    }

    if (!image && description.includes('<img')) {
      const match = description.match(/<img[^>]+src=["']([^"']+)["']/i);
      if (match) image = match[1];
    }

    let link =
      textOf(it.querySelector('link')) ||
      (it.querySelector('link') ? attrOf(it.querySelector('link'), 'href') : '');
    if (!link && title) link = `/blogs/${blogHandle}/${slugify(title)}`;

    return { title, description, image, link };
  };

  // ------------------------
  // 🔹 Main loop for all blocks
  // ------------------------
  for (const block of allBlocks) {
    const rssUrl = block.dataset.feedUrl;
    const feedIndex = parseInt(block.dataset.feedIndex || 0);
    const blogHandle = block.dataset.blog || '';
    const blogId = block.dataset.blogId || '';
    const excludeTags = block.dataset.blogExcludeTags
      ? block.dataset.blogExcludeTags.split(',').map((t) => t.trim()).filter(Boolean)
      : [];
    const includeTags = block.dataset.blogIncludeTags
      ? block.dataset.blogIncludeTags.split(',').map((t) => t.trim()).filter(Boolean)
      : [];

    try {
      let item = null;

      // 🟣 CASE 1: RSS feed + Shopify lookup by title
      if (rssUrl) {
        const response = await fetch(rssUrl);
        if (!response.ok) throw new Error(`Feed HTTP ${response.status}`);
        const xmlText = await response.text();

        const parsed = parseRSS(xmlText, feedIndex, blogHandle);
        if (!parsed) continue;

        // Unified call (title-based fetch)
        const articleData = await fetchArticleDetailsFromShopify({
          title: parsed.title,
          blogHandle,
          excludeTags,
          includeTags,
          blogId
        });

        //item = { ...parsed, ...(articleData || {}) };
        item = { ...(articleData || {}), ...parsed };
        if (articleData?.metafields) item.metafields = articleData.metafields;
      }

      // 🟣 CASE 2: Shopify direct latest post (no RSS)
      else if (blogHandle) {
        const articleData = await fetchArticleDetailsFromShopify({
          blogHandle,
          excludeTags,
          includeTags,
          blogId
        });
        if (!articleData) continue;
        item = articleData;
      }

      if (!item) continue;

      // --- Update DOM ---
      const titleEl = block.querySelector('.api-title');
      if (titleEl && titleEl.dataset.overwrite && titleEl.dataset.overwrite === 'true' && item.title){
        titleEl.textContent = item.title;
      }

      const imgEl = block.querySelector('.multicolumn-card__image');
      if (imgEl && imgEl.dataset.overwrite && imgEl.dataset.overwrite === 'true' && item.image){
        imgEl.src = item.image;
        imgEl.srcset = item.image;
        imgEl.alt = item.title;
        imgEl.loading = 'lazy';
      }

      const textEl = block.querySelector('.api-text');
      if (textEl && textEl.dataset.overwrite && textEl.dataset.overwrite === 'true' && item.description){
        textEl.innerHTML = `<div class="description-ele">${item.description}</div>`;
      }

      const linkEl = block.querySelector('.api-link');
      if (linkEl && linkEl.dataset.overwriteLink && linkEl.dataset.overwriteLink === 'true' && item.link){
        linkEl.href = item.link;
      }

      const episodeNumber = item?.metafields?.episode;
      const episodeNumberEl = block.querySelector('.episode-number');
      if (episodeNumberEl && episodeNumber) {
        episodeNumberEl.textContent = episodeNumberEl.textContent.replace('__EPISODE_NUMBER__', episodeNumber);
      }else{
        episodeNumberEl.textContent = episodeNumberEl.textContent.replace('__EPISODE_NUMBER__', '');
      }
      block.classList.remove('skeleton-active');
      //console.log(`[Feed/Blog Updated]: ${item.title}`, item);
    } catch (err) {
      console.error('[Feed/Blog Error]:', err);
    }
  }
})();

/*
  init Merge Featured Section (Desktop Only with Reversible Restore)
*/

document.addEventListener("DOMContentLoaded", initFeaturedMerge);
window.addEventListener("resize", debounce(initFeaturedMerge, 300));

// Use normal Map (100% safe across Shopify bundlers)
let originalState = new Map();

function initFeaturedMerge() {
  const isDesktop = window.matchMedia("(min-width: 989px)").matches;

  if (isDesktop) {
    applyDesktopMerge();
  } else {
    restoreOriginalState();
  }
}

/* ------------------------------
   DESKTOP MERGING
------------------------------ */
function applyDesktopMerge() {
  const featuredSections = document.querySelectorAll('[data-ele="featured-collection"]');

  featuredSections.forEach(currentFC => {
    if (currentFC.getAttribute("data-move-section-content") !== "true") return;

    const currentSection = currentFC.closest(".shopify-section");
    if (!currentSection) return;

    let previousSection = currentSection.previousElementSibling;
    while (previousSection && !previousSection.classList.contains("shopify-section")) {
      previousSection = previousSection.previousElementSibling;
    }
    if (!previousSection) return;

    const previousFC = previousSection.querySelector('[data-ele="featured-collection"][data-move-section-content="false"]');
    if (!previousFC) return;

    // Avoid duplicate merging
    if (currentSection.classList.contains("merged-featured-collection")) return;

    /* Save original DOM state ONLY ONCE */
    if (!originalState.has(currentSection)) {
      const aside = currentSection.querySelector("aside.products-list-sidebar");
      const list = currentSection.querySelector("products-list ul");

      originalState.set(currentSection, {
        asideNodes: aside ? [...aside.childNodes] : [],
        liNodes: list ? [...list.querySelectorAll("li")] : []
      });
    }

    /* MERGE ASIDE */
    const currentAside = currentSection.querySelector("aside.products-list-sidebar");
    const previousAside = previousSection.querySelector("aside.products-list-sidebar");

    if (currentAside && previousAside) {
      [...currentAside.childNodes].forEach(n => previousAside.appendChild(n));
    }

    /* MERGE PRODUCT LIST ITEMS */
    const currentList = currentSection.querySelector("products-list ul");
    const previousList = previousSection.querySelector("products-list ul");

    if (currentList && previousList) {
      [...currentList.querySelectorAll("li")].forEach(li => previousList.appendChild(li));
    }

    currentSection.classList.add("merged-featured-collection");
  });
}

/* ------------------------------
   RESTORE ORIGINAL STATE
------------------------------ */
function restoreOriginalState() {
  originalState.forEach((state, section) => {

    const aside = section.querySelector("aside.products-list-sidebar");
    const list = section.querySelector("products-list ul");

    // Restore ASIDE DOM
    if (aside) {
      aside.innerHTML = "";
      state.asideNodes.forEach(n => aside.appendChild(n));
    }

    // Restore LIST DOM
    if (list) {
      list.innerHTML = "";
      state.liNodes.forEach(li => list.appendChild(li));
    }

    section.classList.remove("merged-featured-collection");
  });
}

/* ------------------------------
   Debounce Utility
------------------------------ */
function debounce(fn, delay) {
  let timer;
  return function () {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, arguments), delay);
  };
}
